'use strict';

var jssPluginRuleValueFunction_esm = require('../../../../jss-plugin-rule-value-function/dist/jss-plugin-rule-value-function.esm.js');
var jssPluginGlobal_esm = require('../../../../jss-plugin-global/dist/jss-plugin-global.esm.js');
var jssPluginNested_esm = require('../../../../jss-plugin-nested/dist/jss-plugin-nested.esm.js');
var jssPluginCamelCase_esm = require('../../../../jss-plugin-camel-case/dist/jss-plugin-camel-case.esm.js');
var jssPluginDefaultUnit_esm = require('../../../../jss-plugin-default-unit/dist/jss-plugin-default-unit.esm.js');
var jssPluginVendorPrefixer_esm = require('../../../../jss-plugin-vendor-prefixer/dist/jss-plugin-vendor-prefixer.esm.js');
var jssPluginPropsSort_esm = require('../../../../jss-plugin-props-sort/dist/jss-plugin-props-sort.esm.js');

function jssPreset() {
  return {
    plugins: [jssPluginRuleValueFunction_esm(), jssPluginGlobal_esm(), jssPluginNested_esm(), jssPluginCamelCase_esm(), jssPluginDefaultUnit_esm(), // Disable the vendor prefixer server-side, it does nothing.
    // This way, we can get a performance boost.
    // In the documentation, we are using `autoprefixer` to solve this problem.
    typeof window === 'undefined' ? null : jssPluginVendorPrefixer_esm(), jssPluginPropsSort_esm()]
  };
}

module.exports = jssPreset;
